<template>
    <div class="div-main-filter">
        <div>
            <Button _key="btnFilter" tooltip="Aplicar Filtros" color="black" backGroundColor="#F0F0F0" title="Filtros"
                classIcon="fa-sharp fa-solid fa-filters" size="small" :clicked="openFilter" />

            <div class="side-by-side" v-for="item in tags">
                <div class="div-tag">
                    <Tag v-if="item.value" eventName="eventName" :params="item" eventData="tag"
                        :clickedBody="openFilter" :clickedRemove="removeTag" :title="item.title" :value="item.value"
                        :tagRemoved="false" />
                </div>
            </div>
        </div>

        <Modal title="Filtros" :width="700" :height="750" v-show="showModal('filter')">
            <slot></slot>
            <FilterBuilder :filters="filters" v-model="filterFinal" />
        </Modal>
    </div>
</template>

<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import FilterBuilder from "./FilterBuilder.vue";
import Tag from "@nixweb/nixloc-ui/src/component/layout/Tag";

import { mapGetters, mapMutations } from "vuex";


export default {
    name: "FilterQuery",
    props: ["filters", "showDateYearMonth", "value"],
    components: {
        Button, Modal, FilterBuilder, Tag
    },
    data() {
        return {
            filterFinal: [],
            tags: [],
        }
    },
    computed: {
        ...mapGetters("generic", ["showModal", "event"]),
    },
    methods: {
        ...mapMutations("generic", ["openModal", "addEvent", "removeLoading", "updateQueryTags", "updateFilterFinal"]),
        openFilter() {
            this.openModal("filter");
            this.removeLoading(["btnFilter"]);
        },
        removeTag(params) {
            this.tags = this.tags.filter(item => item.field !== params.field);
            this.addEvent({ name: "tagFilterRemove", data: params });
        }
    },
    watch: {
        event: {
            handler(event) {
                if (event.name == "stringFilter") {
                    var data = JSON.stringify(event.data);
                    this.tags = JSON.parse(data);
                }
            },
            deep: true,
        },
        filterFinal: {
            handler(filterFinal) {
                this.$emit("input", filterFinal);
                this.updateFilterFinal(filterFinal);
            },
            deep: true,
        },
        tags: {
            handler(tags) {
                this.updateQueryTags(tags);
            },
            deep: true,
        },
    },

}

</script>.
<style>
.div-tag {
    margin-left: 2px;
}
</style>
